export default __webpack_public_path__ + "static/media/Logo_2_1.40a886c0.png";